import _ from 'lodash';
import React from 'react';
import { inject, observer } from 'mobx-react';

import { autorun } from 'mobx';

import Root from './root';

function isLoading (...stores) {
	let isLoading = false;

	_.each(stores, (store) => {
		if (store.isLoading) {

			isLoading = true;
			return false;
		}
	});

	return isLoading;
}

@inject('artistStore', 'userStore', 'genreStore', 'songsStore')
class Loading extends React.Component {
	state = {
		displayReady: false
	};

	constructor (props) {
		super(props);

		if (this.props.fetchStoreData !== true) {

			return;
		}

		const { artistStore, userStore, genreStore, songsStore } = this.props;

		userStore.fetchItems();
		artistStore.fetchItems();
		genreStore.fetchItems();
		songsStore.fetchItems();

		// Use autorun to only observe this state change once
		const disposer = autorun(() => {
			if (isLoading(artistStore, userStore, genreStore, songsStore) !== true) {

				this.setState({
					displayReady: true
				});

				disposer();
			}
		});
	}

	render () {
		if (this.state.displayReady !== true) {

			return (<div className="loading-spinner large"></div>);
		}

		return( <Root /> );
	}
}

export default Loading;
